const CardSkeleton = ({className}) => {
    return (
        <div className={`pb-[10px] md:mx-auto md:pb-4 ${className}`}>
            <div className={"bg-gray-300 border rounded-md w-auto  px-6 py-4 mb-5 md:mb-9"}>
                <div className="flex justify-between">
                    <div className="w-full">
                        <div className="flex justify-between gap-x-5 md:items-start mb-12">
                            <div className="flex gap-x-1">
                                <div className="w-[200px]  md:w-[300px] animate-pulse bg-gray-200 rounded-md h-11"></div>
                            </div>
                            <div className="w-[250px]   animate-pulse bg-gray-200 rounded-md h-11"></div>
                        </div>

                        <div className="w-[250px] md:w-full animate-pulse bg-gray-200 rounded-md h-9 mb-4"></div>
                        <div className="w-[250px] md:w-full animate-pulse bg-gray-200 rounded-md h-9 mb-4"></div>
                        <div className="w-[250px] md:w-full animate-pulse bg-gray-200 rounded-md h-9 mb-4"></div>
                    </div>
                </div>
                <div></div>
            </div>
            <div className={"bg-gray-300 border rounded-md w-auto  px-6 py-4 mb-5 md:mb-9"}>
                <div className="flex justify-between">
                    <div className="w-full">
                        <div className="flex justify-between gap-x-5 md:items-start mb-12">
                            <div className="flex gap-x-1">
                                <div className="w-[200px]  md:w-[300px] animate-pulse bg-gray-200 rounded-md h-11"></div>
                            </div>
                            <div className="w-[250px]   animate-pulse bg-gray-200 rounded-md h-11"></div>
                        </div>

                        <div className="w-[250px] md:w-full animate-pulse bg-gray-200 rounded-md h-9 mb-4"></div>
                        <div className="w-[250px] md:w-full animate-pulse bg-gray-200 rounded-md h-9 mb-4"></div>
                        <div className="w-[250px] md:w-full animate-pulse bg-gray-200 rounded-md h-9 mb-4"></div>
                    </div>
                </div>
                <div></div>
            </div>
            <div className={"bg-gray-300 border rounded-md w-auto  px-6 py-4 mb-5 md:mb-9"}>
                <div className="flex justify-between">
                    <div className="w-full">
                        <div className="flex justify-between gap-x-5 md:items-start mb-12">
                            <div className="flex gap-x-1">
                                <div className="w-[200px]  md:w-[300px] animate-pulse bg-gray-200 rounded-md h-11"></div>
                            </div>
                            <div className="w-[250px]   animate-pulse bg-gray-200 rounded-md h-11"></div>
                        </div>

                        <div className="w-[250px] md:w-full animate-pulse bg-gray-200 rounded-md h-9 mb-4"></div>
                        <div className="w-[250px] md:w-full animate-pulse bg-gray-200 rounded-md h-9 mb-4"></div>
                        <div className="w-[250px] md:w-full animate-pulse bg-gray-200 rounded-md h-9 mb-4"></div>
                    </div>
                </div>
                <div></div>
            </div>
            <div className={"bg-gray-300 border rounded-md w-auto  px-6 py-4 mb-5 md:mb-9"}>
                <div className="flex justify-between">
                    <div className="w-full">
                        <div className="flex justify-between gap-x-5 md:items-start mb-12">
                            <div className="flex gap-x-1">
                                <div className="w-[200px]  md:w-[300px] animate-pulse bg-gray-200 rounded-md h-11"></div>
                            </div>
                            <div className="w-[250px]   animate-pulse bg-gray-200 rounded-md h-11"></div>
                        </div>

                        <div className="w-[250px] md:w-full animate-pulse bg-gray-200 rounded-md h-9 mb-4"></div>
                        <div className="w-[250px] md:w-full animate-pulse bg-gray-200 rounded-md h-9 mb-4"></div>
                        <div className="w-[250px] md:w-full animate-pulse bg-gray-200 rounded-md h-9 mb-4"></div>
                    </div>
                </div>
                <div></div>
            </div>
        </div>
    );
};
export default CardSkeleton;
